import { z } from 'zod';
// Platform identifier for Stripe metadata filtering
export const PLATFORM_NAME = 'wafer_inventory';
export var CONTAINER_TYPE;
(function (CONTAINER_TYPE) {
    CONTAINER_TYPE["FOUP"] = "FOUP";
    CONTAINER_TYPE["FOSB"] = "FOSB";
    CONTAINER_TYPE["ClamShell"] = "ClamShell";
})(CONTAINER_TYPE || (CONTAINER_TYPE = {}));
;
export var CONTAINER_SIZE;
(function (CONTAINER_SIZE) {
    CONTAINER_SIZE["Size150mm"] = "150mm";
    CONTAINER_SIZE["Size200mm"] = "200mm";
    CONTAINER_SIZE["Size300mm"] = "300mm";
    CONTAINER_SIZE["Size450mm"] = "450mm";
})(CONTAINER_SIZE || (CONTAINER_SIZE = {}));
export var CONTAINER_STATUS;
(function (CONTAINER_STATUS) {
    CONTAINER_STATUS["Available"] = "Available";
    CONTAINER_STATUS["Shipped"] = "Shipped";
    CONTAINER_STATUS["Lost"] = "Lost";
})(CONTAINER_STATUS || (CONTAINER_STATUS = {}));
export var WAFER_STATUS;
(function (WAFER_STATUS) {
    WAFER_STATUS["Available"] = "Available";
    WAFER_STATUS["Shipped"] = "Shipped";
    WAFER_STATUS["Lost"] = "Lost";
    /** In inventory but container/slot unknown (audit missing, reassign displacement, etc.) */
    WAFER_STATUS["Unlocated"] = "Unlocated";
})(WAFER_STATUS || (WAFER_STATUS = {}));
export var WAFER_PATTERN_TYPE;
(function (WAFER_PATTERN_TYPE) {
    WAFER_PATTERN_TYPE["Patterned"] = "Patterned";
    WAFER_PATTERN_TYPE["Unpatterned"] = "Unpatterned";
})(WAFER_PATTERN_TYPE || (WAFER_PATTERN_TYPE = {}));
export var WAFER_MATERIAL_TYPE;
(function (WAFER_MATERIAL_TYPE) {
    WAFER_MATERIAL_TYPE["Silicon"] = "Silicon";
    WAFER_MATERIAL_TYPE["Quartz"] = "Quartz";
    WAFER_MATERIAL_TYPE["GaN"] = "GaN";
    WAFER_MATERIAL_TYPE["Others"] = "Others";
})(WAFER_MATERIAL_TYPE || (WAFER_MATERIAL_TYPE = {}));
export var WAFER_THICKNESS_TYPE;
(function (WAFER_THICKNESS_TYPE) {
    WAFER_THICKNESS_TYPE["Standard"] = "Standard";
    WAFER_THICKNESS_TYPE["Thick"] = "Thick";
    WAFER_THICKNESS_TYPE["Thin"] = "Thin";
})(WAFER_THICKNESS_TYPE || (WAFER_THICKNESS_TYPE = {}));
export var WAFER_SIZE;
(function (WAFER_SIZE) {
    WAFER_SIZE["Size150mm"] = "150mm";
    WAFER_SIZE["Size200mm"] = "200mm";
    WAFER_SIZE["Size300mm"] = "300mm";
    WAFER_SIZE["Size450mm"] = "450mm";
})(WAFER_SIZE || (WAFER_SIZE = {}));
export var EFEM_LOAD_PORT_SIZE;
(function (EFEM_LOAD_PORT_SIZE) {
    EFEM_LOAD_PORT_SIZE["Size200mm"] = "200mm";
    EFEM_LOAD_PORT_SIZE["Size300mm"] = "300mm";
    EFEM_LOAD_PORT_SIZE["Size450mm"] = "450mm";
})(EFEM_LOAD_PORT_SIZE || (EFEM_LOAD_PORT_SIZE = {}));
export var ALL_USER_ROLES;
(function (ALL_USER_ROLES) {
    ALL_USER_ROLES["provider_admin"] = "provider_admin";
    ALL_USER_ROLES["provider_engineer"] = "provider_engineer";
    ALL_USER_ROLES["provider_support"] = "provider_support";
    ALL_USER_ROLES["provider_deployment_engineer"] = "provider_deployment_engineer";
    ALL_USER_ROLES["tenant_admin"] = "tenant_admin";
    ALL_USER_ROLES["tenant_lead"] = "tenant_lead";
    ALL_USER_ROLES["tenant_engineer"] = "tenant_engineer";
    ALL_USER_ROLES["unknown"] = "unknown";
})(ALL_USER_ROLES || (ALL_USER_ROLES = {}));
export var USER_TYPE;
(function (USER_TYPE) {
    USER_TYPE["tenant"] = "tenant";
    USER_TYPE["provider"] = "provider";
})(USER_TYPE || (USER_TYPE = {}));
export var BULK_OPERATION_TYPE;
(function (BULK_OPERATION_TYPE) {
    BULK_OPERATION_TYPE["import"] = "import";
    BULK_OPERATION_TYPE["export"] = "export";
    BULK_OPERATION_TYPE["delete"] = "delete";
    BULK_OPERATION_TYPE["backup"] = "backup";
    BULK_OPERATION_TYPE["restore"] = "restore";
})(BULK_OPERATION_TYPE || (BULK_OPERATION_TYPE = {}));
export var SUBSCRIPTION_STATUS;
(function (SUBSCRIPTION_STATUS) {
    SUBSCRIPTION_STATUS["Active"] = "active";
    SUBSCRIPTION_STATUS["Trialing"] = "trialing";
    SUBSCRIPTION_STATUS["Paused"] = "paused";
    SUBSCRIPTION_STATUS["PastDue"] = "past_due";
    SUBSCRIPTION_STATUS["Canceled"] = "canceled";
    SUBSCRIPTION_STATUS["Incomplete"] = "incomplete";
    SUBSCRIPTION_STATUS["Expired"] = "expired";
})(SUBSCRIPTION_STATUS || (SUBSCRIPTION_STATUS = {}));
/** How subscription billing is collected — Stripe self-serve vs manual enterprise (Zoho/Mercury). */
export var BILLING_MODE;
(function (BILLING_MODE) {
    BILLING_MODE["Stripe"] = "stripe";
    BILLING_MODE["EnterpriseManual"] = "enterprise_manual";
})(BILLING_MODE || (BILLING_MODE = {}));
/** Enterprise package kind — pilot evaluation vs annual contract package. */
export var ENTERPRISE_PACKAGE_KIND;
(function (ENTERPRISE_PACKAGE_KIND) {
    ENTERPRISE_PACKAGE_KIND["Pilot"] = "pilot";
    ENTERPRISE_PACKAGE_KIND["Annual"] = "annual";
    ENTERPRISE_PACKAGE_KIND["Amendment"] = "amendment";
})(ENTERPRISE_PACKAGE_KIND || (ENTERPRISE_PACKAGE_KIND = {}));
export var BILLING_CYCLE;
(function (BILLING_CYCLE) {
    BILLING_CYCLE["Monthly"] = "monthly";
    BILLING_CYCLE["Yearly"] = "yearly";
})(BILLING_CYCLE || (BILLING_CYCLE = {}));
export var BILLING_RESOURCE_TYPE;
(function (BILLING_RESOURCE_TYPE) {
    BILLING_RESOURCE_TYPE["Base"] = "base";
    BILLING_RESOURCE_TYPE["Wafers"] = "wafers";
    BILLING_RESOURCE_TYPE["Containers"] = "containers";
    BILLING_RESOURCE_TYPE["Users"] = "users";
    BILLING_RESOURCE_TYPE["AxonGateways"] = "axon_gateways";
    BILLING_RESOURCE_TYPE["Storage"] = "storage";
    BILLING_RESOURCE_TYPE["Encryption"] = "encryption";
})(BILLING_RESOURCE_TYPE || (BILLING_RESOURCE_TYPE = {}));
// Wafer audit status types:
// OK - Wafer present in expected slot with correct fingerprint
// Mismatch - Wafer present in expected slot but fingerprint does not match database
// GhostWafer - Physical wafer found but no corresponding database record (extra wafer)
// MissingWafer - Database record exists but physical wafer not found in expected slot
// NotAudited - Wafer has not been audited yet
export var WAFER_AUDIT_STATUS;
(function (WAFER_AUDIT_STATUS) {
    WAFER_AUDIT_STATUS["OK"] = "OK";
    WAFER_AUDIT_STATUS["Mismatch"] = "Mismatch";
    WAFER_AUDIT_STATUS["GhostWafer"] = "GhostWafer";
    WAFER_AUDIT_STATUS["MissingWafer"] = "MissingWafer";
    WAFER_AUDIT_STATUS["NotAudited"] = "NotAudited";
})(WAFER_AUDIT_STATUS || (WAFER_AUDIT_STATUS = {}));
// Wafer conflict management enums
export var WAFER_CONFLICT_TYPE;
(function (WAFER_CONFLICT_TYPE) {
    WAFER_CONFLICT_TYPE["GhostWafer"] = "GhostWafer";
    WAFER_CONFLICT_TYPE["MissingWafer"] = "MissingWafer";
    WAFER_CONFLICT_TYPE["Mismatch"] = "Mismatch";
    WAFER_CONFLICT_TYPE["Lost"] = "Lost";
    WAFER_CONFLICT_TYPE["Duplicate"] = "Duplicate";
    WAFER_CONFLICT_TYPE["TransferFailure"] = "TransferFailure";
})(WAFER_CONFLICT_TYPE || (WAFER_CONFLICT_TYPE = {}));
export var CONFLICT_STATUS;
(function (CONFLICT_STATUS) {
    CONFLICT_STATUS["Open"] = "Open";
    CONFLICT_STATUS["UnderReview"] = "UnderReview";
    CONFLICT_STATUS["Resolved"] = "Resolved";
    CONFLICT_STATUS["Dismissed"] = "Dismissed";
    CONFLICT_STATUS["Escalated"] = "Escalated";
    CONFLICT_STATUS["Superseded"] = "Superseded";
})(CONFLICT_STATUS || (CONFLICT_STATUS = {}));
export var CONFLICT_SEVERITY;
(function (CONFLICT_SEVERITY) {
    CONFLICT_SEVERITY["Critical"] = "Critical";
    CONFLICT_SEVERITY["High"] = "High";
    CONFLICT_SEVERITY["Medium"] = "Medium";
    CONFLICT_SEVERITY["Low"] = "Low";
})(CONFLICT_SEVERITY || (CONFLICT_SEVERITY = {}));
export var RESOLUTION_ACTION;
(function (RESOLUTION_ACTION) {
    RESOLUTION_ACTION["CorrectDatabase"] = "CorrectDatabase";
    RESOLUTION_ACTION["CorrectPhysical"] = "CorrectPhysical";
    RESOLUTION_ACTION["MarkAsLost"] = "MarkAsLost";
    RESOLUTION_ACTION["MarkAsDispatched"] = "MarkAsDispatched";
    RESOLUTION_ACTION["MarkAsUnlocated"] = "MarkAsUnlocated";
    RESOLUTION_ACTION["CreateNewRecord"] = "CreateNewRecord";
    RESOLUTION_ACTION["LinkExistingWafer"] = "LinkExistingWafer";
    RESOLUTION_ACTION["UpdateFingerprintFromScan"] = "UpdateFingerprintFromScan";
    RESOLUTION_ACTION["DismissInvalidScan"] = "DismissInvalidScan";
    RESOLUTION_ACTION["ReassignSlotOccupancy"] = "ReassignSlotOccupancy";
    RESOLUTION_ACTION["ReconcileSlotSwap"] = "ReconcileSlotSwap";
    RESOLUTION_ACTION["ReconcileOccupancy"] = "ReconcileOccupancy";
    RESOLUTION_ACTION["RemoveFromDatabase"] = "RemoveFromDatabase";
    RESOLUTION_ACTION["MoveWafer"] = "MoveWafer";
    RESOLUTION_ACTION["ReplaceWafer"] = "ReplaceWafer";
    RESOLUTION_ACTION["RetryTransfer"] = "RetryTransfer";
    RESOLUTION_ACTION["NoActionRequired"] = "NoActionRequired";
})(RESOLUTION_ACTION || (RESOLUTION_ACTION = {}));
/** Persisted on audit_run.run_status */
export var AUDIT_RUN_STATUS;
(function (AUDIT_RUN_STATUS) {
    AUDIT_RUN_STATUS["pass"] = "pass";
    AUDIT_RUN_STATUS["needs_action"] = "needs_action";
    AUDIT_RUN_STATUS["resolved"] = "resolved";
})(AUDIT_RUN_STATUS || (AUDIT_RUN_STATUS = {}));
// OCR conflict resolution methods
export var OCR_RESOLUTION_METHOD;
(function (OCR_RESOLUTION_METHOD) {
    OCR_RESOLUTION_METHOD["StrongConsensus"] = "strong_consensus";
    OCR_RESOLUTION_METHOD["SimilarityAnalysis"] = "similarity_analysis";
    OCR_RESOLUTION_METHOD["CharacterVoting"] = "character_voting";
    OCR_RESOLUTION_METHOD["QualityWeighted"] = "quality_weighted";
    OCR_RESOLUTION_METHOD["SingleImage"] = "single_image";
    OCR_RESOLUTION_METHOD["AllRejected"] = "all_rejected";
    OCR_RESOLUTION_METHOD["ManualEntry"] = "manual_entry";
    OCR_RESOLUTION_METHOD["UserOverride"] = "user_override";
    OCR_RESOLUTION_METHOD["Error"] = "error";
})(OCR_RESOLUTION_METHOD || (OCR_RESOLUTION_METHOD = {}));
export var BACON_STATUS;
(function (BACON_STATUS) {
    BACON_STATUS["Active"] = "Active";
    BACON_STATUS["Inactive"] = "Inactive";
    BACON_STATUS["LowBattery"] = "LowBattery";
    BACON_STATUS["Malfunction"] = "Malfunction";
    BACON_STATUS["Maintenance"] = "Maintenance";
})(BACON_STATUS || (BACON_STATUS = {}));
export var CONTAINER_HISTORY_EVENT;
(function (CONTAINER_HISTORY_EVENT) {
    CONTAINER_HISTORY_EVENT["CREATED"] = "CREATED";
    CONTAINER_HISTORY_EVENT["UPDATED"] = "UPDATED";
    CONTAINER_HISTORY_EVENT["STATUS_CHANGED"] = "STATUS_CHANGED";
    CONTAINER_HISTORY_EVENT["WAFER_ADDED"] = "WAFER_ADDED";
    CONTAINER_HISTORY_EVENT["WAFER_REMOVED"] = "WAFER_REMOVED";
    CONTAINER_HISTORY_EVENT["BEACON_ASSIGNED"] = "BEACON_ASSIGNED";
    CONTAINER_HISTORY_EVENT["BEACON_REMOVED"] = "BEACON_REMOVED";
    CONTAINER_HISTORY_EVENT["LOCATION_CHANGED"] = "LOCATION_CHANGED";
})(CONTAINER_HISTORY_EVENT || (CONTAINER_HISTORY_EVENT = {}));
export var WAFER_HISTORY_EVENT;
(function (WAFER_HISTORY_EVENT) {
    WAFER_HISTORY_EVENT["CREATED"] = "CREATED";
    WAFER_HISTORY_EVENT["UPDATED"] = "UPDATED";
    WAFER_HISTORY_EVENT["STATUS_CHANGED"] = "STATUS_CHANGED";
    WAFER_HISTORY_EVENT["TRANSFERRED"] = "TRANSFERRED";
    WAFER_HISTORY_EVENT["SHIPPED"] = "SHIPPED";
    WAFER_HISTORY_EVENT["LOST"] = "LOST";
    WAFER_HISTORY_EVENT["FINGERPRINT_UPDATED"] = "FINGERPRINT_UPDATED";
    WAFER_HISTORY_EVENT["RETURNED"] = "RETURNED";
})(WAFER_HISTORY_EVENT || (WAFER_HISTORY_EVENT = {}));
/** How a wafer container/slot change was initiated (stored on wafer_transfer_history). */
export var WAFER_TRANSFER_SOURCE;
(function (WAFER_TRANSFER_SOURCE) {
    WAFER_TRANSFER_SOURCE["ManualDetailPanel"] = "manual_detail_panel";
    WAFER_TRANSFER_SOURCE["ManualTransferApi"] = "manual_transfer_api";
    WAFER_TRANSFER_SOURCE["EfemBatchTransfer"] = "efem_batch_transfer";
    WAFER_TRANSFER_SOURCE["SystemCreate"] = "system_create";
    WAFER_TRANSFER_SOURCE["ConflictResolution"] = "conflict_resolution";
    WAFER_TRANSFER_SOURCE["Legacy"] = "legacy";
})(WAFER_TRANSFER_SOURCE || (WAFER_TRANSFER_SOURCE = {}));
export function formatWaferTransferSourceLabel(source) {
    switch (source) {
        case WAFER_TRANSFER_SOURCE.ManualDetailPanel:
            return 'Manual (wafer detail)';
        case WAFER_TRANSFER_SOURCE.ManualTransferApi:
            return 'Manual (transfer tool)';
        case WAFER_TRANSFER_SOURCE.EfemBatchTransfer:
            return 'EFEM batch transfer';
        case WAFER_TRANSFER_SOURCE.SystemCreate:
            return 'Wafer created';
        case WAFER_TRANSFER_SOURCE.ConflictResolution:
            return 'Conflict resolution';
        case WAFER_TRANSFER_SOURCE.Legacy:
            return 'Legacy / unknown';
        default:
            return source?.trim() ? source : 'Unknown';
    }
}
export var ONLINE_OFFLINE_STATUS;
(function (ONLINE_OFFLINE_STATUS) {
    ONLINE_OFFLINE_STATUS["ONLINE"] = "online";
    ONLINE_OFFLINE_STATUS["OFFLINE"] = "offline";
})(ONLINE_OFFLINE_STATUS || (ONLINE_OFFLINE_STATUS = {}));
export var LOAD_PORT_STATUS;
(function (LOAD_PORT_STATUS) {
    LOAD_PORT_STATUS["EMPTY"] = "EMPTY";
    LOAD_PORT_STATUS["DETECTED"] = "DETECTED";
    LOAD_PORT_STATUS["LOADED"] = "LOADED";
    LOAD_PORT_STATUS["ERROR"] = "ERROR";
})(LOAD_PORT_STATUS || (LOAD_PORT_STATUS = {}));
/** Cloud load-port ↔ container binding resolution (efem_load_port_bindings). */
export var EFEM_LOAD_PORT_BINDING_STATUS;
(function (EFEM_LOAD_PORT_BINDING_STATUS) {
    EFEM_LOAD_PORT_BINDING_STATUS["MATCHED"] = "matched";
    EFEM_LOAD_PORT_BINDING_STATUS["NOT_FOUND"] = "not_found";
    /** Valid CNP- label not yet linked in inventory_labels (associate in UI first). */
    EFEM_LOAD_PORT_BINDING_STATUS["UNASSIGNED_LABEL"] = "unassigned_label";
    /** Label linked to a non-container entity (e.g. future cage). */
    EFEM_LOAD_PORT_BINDING_STATUS["NOT_SUPPORTED"] = "not_supported";
    EFEM_LOAD_PORT_BINDING_STATUS["PARSE_ERROR"] = "parse_error";
    EFEM_LOAD_PORT_BINDING_STATUS["AMBIGUOUS"] = "ambiguous";
    EFEM_LOAD_PORT_BINDING_STATUS["CONFLICT"] = "conflict";
    EFEM_LOAD_PORT_BINDING_STATUS["CLEARED"] = "cleared";
})(EFEM_LOAD_PORT_BINDING_STATUS || (EFEM_LOAD_PORT_BINDING_STATUS = {}));
export var EFEM_LOAD_PORT_BINDING_SOURCE;
(function (EFEM_LOAD_PORT_BINDING_SOURCE) {
    EFEM_LOAD_PORT_BINDING_SOURCE["PASSIVE"] = "passive";
    EFEM_LOAD_PORT_BINDING_SOURCE["COMMAND"] = "command";
    EFEM_LOAD_PORT_BINDING_SOURCE["MANUAL"] = "manual";
    EFEM_LOAD_PORT_BINDING_SOURCE["HANDHELD"] = "handheld";
    EFEM_LOAD_PORT_BINDING_SOURCE["CLEARED"] = "cleared";
})(EFEM_LOAD_PORT_BINDING_SOURCE || (EFEM_LOAD_PORT_BINDING_SOURCE = {}));
// EFEM Scan Status - Backend database status
export var EFEM_SCAN_STATUS;
(function (EFEM_SCAN_STATUS) {
    EFEM_SCAN_STATUS["Initiated"] = "initiated";
    EFEM_SCAN_STATUS["InProgress"] = "in_progress";
    EFEM_SCAN_STATUS["Completed"] = "completed";
    EFEM_SCAN_STATUS["Partial"] = "partial";
    EFEM_SCAN_STATUS["Failed"] = "failed";
    EFEM_SCAN_STATUS["Aborted"] = "aborted"; // Scan canceled
})(EFEM_SCAN_STATUS || (EFEM_SCAN_STATUS = {}));
// EFEM Slot Result Status - Per-slot outcome reported by gateway
export var EFEM_SLOT_STATUS;
(function (EFEM_SLOT_STATUS) {
    EFEM_SLOT_STATUS["Success"] = "success";
    EFEM_SLOT_STATUS["Failed"] = "failed";
    EFEM_SLOT_STATUS["NoWafer"] = "no_wafer";
    EFEM_SLOT_STATUS["Uploading"] = "uploading"; // Intermediate state - image upload in progress
})(EFEM_SLOT_STATUS || (EFEM_SLOT_STATUS = {}));
// EFEM Image Capture Status - Adapter response status
export var EFEM_CAPTURE_STATUS;
(function (EFEM_CAPTURE_STATUS) {
    EFEM_CAPTURE_STATUS["Captured"] = "captured";
    EFEM_CAPTURE_STATUS["NoWafer"] = "no_wafer";
    EFEM_CAPTURE_STATUS["Failed"] = "failed"; // Capture failed
})(EFEM_CAPTURE_STATUS || (EFEM_CAPTURE_STATUS = {}));
// EFEM Upload Status - S3 upload result status
export var EFEM_UPLOAD_STATUS;
(function (EFEM_UPLOAD_STATUS) {
    EFEM_UPLOAD_STATUS["Success"] = "success";
    EFEM_UPLOAD_STATUS["Failed"] = "failed"; // Upload failed
})(EFEM_UPLOAD_STATUS || (EFEM_UPLOAD_STATUS = {}));
// EFEM Command Callback Status - Async command tracking
export var EFEM_CALLBACK_STATUS;
(function (EFEM_CALLBACK_STATUS) {
    EFEM_CALLBACK_STATUS["Pending"] = "pending";
    EFEM_CALLBACK_STATUS["Success"] = "success";
    EFEM_CALLBACK_STATUS["Failed"] = "failed"; // Command failed
})(EFEM_CALLBACK_STATUS || (EFEM_CALLBACK_STATUS = {}));
// EFEM IoT Commands
export var EFEM_IOT_COMMAND;
(function (EFEM_IOT_COMMAND) {
    EFEM_IOT_COMMAND["GET_STATUS"] = "get_status";
    EFEM_IOT_COMMAND["GET_LOADPORTS"] = "get_loadports";
    EFEM_IOT_COMMAND["GET_SLOTMAP"] = "get_slotmap";
    EFEM_IOT_COMMAND["LOAD_CONTAINERS"] = "load_containers";
    EFEM_IOT_COMMAND["UNLOAD_CONTAINERS"] = "unload_containers";
    EFEM_IOT_COMMAND["CAPTURE_WAFER_IMAGES"] = "capture_wafer_images";
    EFEM_IOT_COMMAND["CAPTURE_WAFER_IMAGES_AT_ANGLES"] = "capture_wafer_images_at_angles";
    EFEM_IOT_COMMAND["INSPECT_CONTAINER_SLOT"] = "inspect_container_slot";
    EFEM_IOT_COMMAND["INSPECT_CONTAINER_SLOTS"] = "inspect_container_slots";
    EFEM_IOT_COMMAND["SCAN_CONTAINER"] = "scan_container";
    EFEM_IOT_COMMAND["TRANSFER_WAFER"] = "transfer_wafer";
    EFEM_IOT_COMMAND["EXECUTE_BATCH_WAFER_TRANSFER"] = "execute_batch_wafer_transfer";
    EFEM_IOT_COMMAND["ABORT_BATCH_WAFER_TRANSFER"] = "abort_batch_wafer_transfer";
    EFEM_IOT_COMMAND["ABORT_SCAN"] = "abort_scan";
    EFEM_IOT_COMMAND["PROBE_PERIPHERALS"] = "probe_peripherals";
})(EFEM_IOT_COMMAND || (EFEM_IOT_COMMAND = {}));
/** Per-job lighting resolution for batch scan / recapture (REST only — not on MQTT). */
export var LIGHTING_SOURCE;
(function (LIGHTING_SOURCE) {
    LIGHTING_SOURCE["TEMPLATE_STARTING"] = "template_starting";
    LIGHTING_SOURCE["WAFER_LEARNED"] = "wafer_learned";
})(LIGHTING_SOURCE || (LIGHTING_SOURCE = {}));
/** Unified jobs API job family discriminator */
export var UNIFIED_JOB_TYPE;
(function (UNIFIED_JOB_TYPE) {
    UNIFIED_JOB_TYPE["CONTAINER_SLOT_SCAN"] = "container_slot_scan";
    UNIFIED_JOB_TYPE["BATCH_WAFER_TRANSFER"] = "batch_wafer_transfer";
})(UNIFIED_JOB_TYPE || (UNIFIED_JOB_TYPE = {}));
export var JOB_SUCCESS_TIER;
(function (JOB_SUCCESS_TIER) {
    JOB_SUCCESS_TIER["FULLY_SUCCESSFUL"] = "fully_successful";
    JOB_SUCCESS_TIER["PARTIALLY_SUCCESSFUL"] = "partially_successful";
    JOB_SUCCESS_TIER["FAILED"] = "failed";
    JOB_SUCCESS_TIER["IN_PROGRESS"] = "in_progress";
})(JOB_SUCCESS_TIER || (JOB_SUCCESS_TIER = {}));
export var ENTITY_NOTE_ENTITY_TYPE;
(function (ENTITY_NOTE_ENTITY_TYPE) {
    ENTITY_NOTE_ENTITY_TYPE["CONTAINER"] = "container";
    ENTITY_NOTE_ENTITY_TYPE["WAFER"] = "wafer";
    ENTITY_NOTE_ENTITY_TYPE["WAFER_CONFLICT"] = "wafer_conflict";
})(ENTITY_NOTE_ENTITY_TYPE || (ENTITY_NOTE_ENTITY_TYPE = {}));
export var CONTAINER_WORKFLOW_TYPE;
(function (CONTAINER_WORKFLOW_TYPE) {
    CONTAINER_WORKFLOW_TYPE["CONTAINER_CREATE"] = "container_create";
    CONTAINER_WORKFLOW_TYPE["WAFER_DATA_REFRESH"] = "wafer_data_refresh";
    CONTAINER_WORKFLOW_TYPE["CONTAINER_AUDIT"] = "container_audit";
})(CONTAINER_WORKFLOW_TYPE || (CONTAINER_WORKFLOW_TYPE = {}));
export var CONTAINER_WORKFLOW_DRAFT_STATUS;
(function (CONTAINER_WORKFLOW_DRAFT_STATUS) {
    CONTAINER_WORKFLOW_DRAFT_STATUS["DRAFT"] = "draft";
    CONTAINER_WORKFLOW_DRAFT_STATUS["COMPLETED"] = "completed";
    CONTAINER_WORKFLOW_DRAFT_STATUS["CANCELLED"] = "cancelled";
})(CONTAINER_WORKFLOW_DRAFT_STATUS || (CONTAINER_WORKFLOW_DRAFT_STATUS = {}));
// Batch Scan Orchestrator - Scan status
export var BATCH_SCAN_STATUS;
(function (BATCH_SCAN_STATUS) {
    BATCH_SCAN_STATUS["INITIATED"] = "initiated";
    BATCH_SCAN_STATUS["IN_PROGRESS"] = "in_progress";
    BATCH_SCAN_STATUS["OCR_PROCESSING"] = "ocr_processing";
    BATCH_SCAN_STATUS["COMPLETED"] = "completed";
    BATCH_SCAN_STATUS["PARTIAL"] = "partial";
    BATCH_SCAN_STATUS["FAILED"] = "failed";
    BATCH_SCAN_STATUS["ABORTED"] = "aborted";
})(BATCH_SCAN_STATUS || (BATCH_SCAN_STATUS = {}));
// Batch Scan Orchestrator - Per-slot status
export var SLOT_SCAN_STATUS;
(function (SLOT_SCAN_STATUS) {
    /** Slot not started yet (manifest row only). */
    SLOT_SCAN_STATUS["PENDING"] = "pending";
    /** Edge is picking/capturing/returning; no terminal outcome yet. */
    SLOT_SCAN_STATUS["IN_PROGRESS"] = "in_progress";
    /** Images registered; OCR queue/Lambda still running. */
    SLOT_SCAN_STATUS["OCR_PROCESSING"] = "ocr_processing";
    SLOT_SCAN_STATUS["SUCCESS"] = "success";
    SLOT_SCAN_STATUS["NO_WAFER"] = "no_wafer";
    SLOT_SCAN_STATUS["SCAN_FAILED"] = "scan_failed";
    SLOT_SCAN_STATUS["OCR_FAILED"] = "ocr_failed";
    SLOT_SCAN_STATUS["ABORTED"] = "aborted";
})(SLOT_SCAN_STATUS || (SLOT_SCAN_STATUS = {}));
/** Container slot scan job state machine (replaces BATCH_SCAN_STATUS on new tables). */
export var CONTAINER_SLOT_SCAN_JOB_PHASE;
(function (CONTAINER_SLOT_SCAN_JOB_PHASE) {
    CONTAINER_SLOT_SCAN_JOB_PHASE["CREATED"] = "created";
    CONTAINER_SLOT_SCAN_JOB_PHASE["COMMAND_PUBLISHED"] = "command_published";
    CONTAINER_SLOT_SCAN_JOB_PHASE["CONTAINER_SLOT_SCANNING"] = "container_slot_scanning";
    CONTAINER_SLOT_SCAN_JOB_PHASE["OCR"] = "ocr";
    CONTAINER_SLOT_SCAN_JOB_PHASE["WORKFLOW"] = "workflow";
    CONTAINER_SLOT_SCAN_JOB_PHASE["COMPLETED"] = "completed";
    CONTAINER_SLOT_SCAN_JOB_PHASE["PARTIAL"] = "partial";
    CONTAINER_SLOT_SCAN_JOB_PHASE["FAILED"] = "failed";
    CONTAINER_SLOT_SCAN_JOB_PHASE["ABORTED"] = "aborted";
})(CONTAINER_SLOT_SCAN_JOB_PHASE || (CONTAINER_SLOT_SCAN_JOB_PHASE = {}));
/** Live slot progress mirrored from edge telemetry. */
export var CONTAINER_SLOT_SCAN_SLOT_PHASE;
(function (CONTAINER_SLOT_SCAN_SLOT_PHASE) {
    CONTAINER_SLOT_SCAN_SLOT_PHASE["PENDING"] = "pending";
    CONTAINER_SLOT_SCAN_SLOT_PHASE["PICKING"] = "picking";
    CONTAINER_SLOT_SCAN_SLOT_PHASE["ALIGNING"] = "aligning";
    CONTAINER_SLOT_SCAN_SLOT_PHASE["CAPTURING"] = "capturing";
    CONTAINER_SLOT_SCAN_SLOT_PHASE["RETURNING"] = "returning";
    CONTAINER_SLOT_SCAN_SLOT_PHASE["DONE"] = "done";
})(CONTAINER_SLOT_SCAN_SLOT_PHASE || (CONTAINER_SLOT_SCAN_SLOT_PHASE = {}));
export var CONTAINER_SLOT_SCAN_SLOT_OUTCOME;
(function (CONTAINER_SLOT_SCAN_SLOT_OUTCOME) {
    CONTAINER_SLOT_SCAN_SLOT_OUTCOME["SUCCESS"] = "success";
    CONTAINER_SLOT_SCAN_SLOT_OUTCOME["FAILED"] = "failed";
    CONTAINER_SLOT_SCAN_SLOT_OUTCOME["NO_WAFER"] = "no_wafer";
    CONTAINER_SLOT_SCAN_SLOT_OUTCOME["ABORTED"] = "aborted";
})(CONTAINER_SLOT_SCAN_SLOT_OUTCOME || (CONTAINER_SLOT_SCAN_SLOT_OUTCOME = {}));
export var CONTAINER_SLOT_SCAN_OCR_PHASE;
(function (CONTAINER_SLOT_SCAN_OCR_PHASE) {
    CONTAINER_SLOT_SCAN_OCR_PHASE["PENDING"] = "pending";
    CONTAINER_SLOT_SCAN_OCR_PHASE["PROCESSING"] = "processing";
    CONTAINER_SLOT_SCAN_OCR_PHASE["SUCCEEDED"] = "succeeded";
    CONTAINER_SLOT_SCAN_OCR_PHASE["FAILED"] = "failed";
    CONTAINER_SLOT_SCAN_OCR_PHASE["SKIPPED"] = "skipped";
})(CONTAINER_SLOT_SCAN_OCR_PHASE || (CONTAINER_SLOT_SCAN_OCR_PHASE = {}));
/** Batch wafer transfer job (EFEM robot moves). */
export var BATCH_WAFER_TRANSFER_JOB_PHASE;
(function (BATCH_WAFER_TRANSFER_JOB_PHASE) {
    BATCH_WAFER_TRANSFER_JOB_PHASE["CREATED"] = "created";
    BATCH_WAFER_TRANSFER_JOB_PHASE["COMMAND_PUBLISHED"] = "command_published";
    BATCH_WAFER_TRANSFER_JOB_PHASE["TRANSFERRING"] = "transferring";
    BATCH_WAFER_TRANSFER_JOB_PHASE["COMPLETING"] = "completing";
    BATCH_WAFER_TRANSFER_JOB_PHASE["COMPLETED"] = "completed";
    BATCH_WAFER_TRANSFER_JOB_PHASE["PARTIAL"] = "partial";
    BATCH_WAFER_TRANSFER_JOB_PHASE["FAILED"] = "failed";
    BATCH_WAFER_TRANSFER_JOB_PHASE["ABORTED"] = "aborted";
})(BATCH_WAFER_TRANSFER_JOB_PHASE || (BATCH_WAFER_TRANSFER_JOB_PHASE = {}));
export var BATCH_WAFER_TRANSFER_ITEM_PHASE;
(function (BATCH_WAFER_TRANSFER_ITEM_PHASE) {
    BATCH_WAFER_TRANSFER_ITEM_PHASE["PENDING"] = "pending";
    BATCH_WAFER_TRANSFER_ITEM_PHASE["PICKING"] = "picking";
    BATCH_WAFER_TRANSFER_ITEM_PHASE["MOVING"] = "moving";
    BATCH_WAFER_TRANSFER_ITEM_PHASE["PLACING"] = "placing";
    BATCH_WAFER_TRANSFER_ITEM_PHASE["DONE"] = "done";
})(BATCH_WAFER_TRANSFER_ITEM_PHASE || (BATCH_WAFER_TRANSFER_ITEM_PHASE = {}));
export var BATCH_WAFER_TRANSFER_ITEM_OUTCOME;
(function (BATCH_WAFER_TRANSFER_ITEM_OUTCOME) {
    BATCH_WAFER_TRANSFER_ITEM_OUTCOME["SUCCESS"] = "success";
    BATCH_WAFER_TRANSFER_ITEM_OUTCOME["FAILED"] = "failed";
    BATCH_WAFER_TRANSFER_ITEM_OUTCOME["ABORTED"] = "aborted";
})(BATCH_WAFER_TRANSFER_ITEM_OUTCOME || (BATCH_WAFER_TRANSFER_ITEM_OUTCOME = {}));
export var FINGERPRINT_INFERENCE_BATCH_PHASE;
(function (FINGERPRINT_INFERENCE_BATCH_PHASE) {
    FINGERPRINT_INFERENCE_BATCH_PHASE["CREATED"] = "created";
    FINGERPRINT_INFERENCE_BATCH_PHASE["INFERRING"] = "inferring";
    FINGERPRINT_INFERENCE_BATCH_PHASE["RESOLVED"] = "resolved";
    FINGERPRINT_INFERENCE_BATCH_PHASE["FAILED"] = "failed";
})(FINGERPRINT_INFERENCE_BATCH_PHASE || (FINGERPRINT_INFERENCE_BATCH_PHASE = {}));
export var FINGERPRINT_INFERENCE_BATCH_CONTEXT;
(function (FINGERPRINT_INFERENCE_BATCH_CONTEXT) {
    FINGERPRINT_INFERENCE_BATCH_CONTEXT["MANUAL_DIAGNOSTIC"] = "manual_diagnostic";
    FINGERPRINT_INFERENCE_BATCH_CONTEXT["WAFER_REVIEW"] = "wafer_review";
    FINGERPRINT_INFERENCE_BATCH_CONTEXT["ML_VALIDATION"] = "ml_validation";
    FINGERPRINT_INFERENCE_BATCH_CONTEXT["RECAPTURE_PREVIEW"] = "recapture_preview";
    /** Manual wafer-ID grab at prealigner (no EFEM motion from Cnapse). */
    FINGERPRINT_INFERENCE_BATCH_CONTEXT["STATION_ACQUIRE"] = "station_acquire";
})(FINGERPRINT_INFERENCE_BATCH_CONTEXT || (FINGERPRINT_INFERENCE_BATCH_CONTEXT = {}));
// Batch Scan Orchestrator - OCR error classification
export var OCR_ERROR_TYPE;
(function (OCR_ERROR_TYPE) {
    OCR_ERROR_TYPE["TRANSIENT"] = "transient";
    OCR_ERROR_TYPE["PERMANENT"] = "permanent";
    OCR_ERROR_TYPE["QUALITY"] = "quality";
})(OCR_ERROR_TYPE || (OCR_ERROR_TYPE = {}));
// OCR_CONTEXT
export var OCR_CONTEXT_TYPE;
(function (OCR_CONTEXT_TYPE) {
    OCR_CONTEXT_TYPE["EFEM_SCAN"] = "efem_scan";
    OCR_CONTEXT_TYPE["MANUAL_UPLOAD"] = "manual_upload";
    OCR_CONTEXT_TYPE["AUDIT"] = "audit";
})(OCR_CONTEXT_TYPE || (OCR_CONTEXT_TYPE = {}));
// IoT Device Status
export var IOT_STATUS;
(function (IOT_STATUS) {
    IOT_STATUS["PROVISIONED"] = "provisioned";
    IOT_STATUS["ACTIVE"] = "active";
    IOT_STATUS["REVOKED"] = "revoked";
})(IOT_STATUS || (IOT_STATUS = {}));
// Health Check Status
export var HEALTH_STATUS;
(function (HEALTH_STATUS) {
    HEALTH_STATUS["OK"] = "ok";
    HEALTH_STATUS["DEGRADED"] = "degraded";
    HEALTH_STATUS["ERROR"] = "error";
})(HEALTH_STATUS || (HEALTH_STATUS = {}));
export var HEALTH_CHECK_STATUS;
(function (HEALTH_CHECK_STATUS) {
    HEALTH_CHECK_STATUS["OK"] = "ok";
    HEALTH_CHECK_STATUS["DISCONNECTED"] = "disconnected";
    HEALTH_CHECK_STATUS["ERROR"] = "error";
    HEALTH_CHECK_STATUS["UNKNOWN"] = "unknown";
})(HEALTH_CHECK_STATUS || (HEALTH_CHECK_STATUS = {}));
export var READINESS_STATUS;
(function (READINESS_STATUS) {
    READINESS_STATUS["READY"] = "ready";
    READINESS_STATUS["NOT_READY"] = "not ready";
})(READINESS_STATUS || (READINESS_STATUS = {}));
export var LIVENESS_STATUS;
(function (LIVENESS_STATUS) {
    LIVENESS_STATUS["ALIVE"] = "alive";
})(LIVENESS_STATUS || (LIVENESS_STATUS = {}));
export var ML_COMPONENT_STATUS;
(function (ML_COMPONENT_STATUS) {
    ML_COMPONENT_STATUS["READY"] = "ready";
    ML_COMPONENT_STATUS["NOT_READY"] = "notReady";
})(ML_COMPONENT_STATUS || (ML_COMPONENT_STATUS = {}));
export var IMAGE_QUALITY;
(function (IMAGE_QUALITY) {
    IMAGE_QUALITY["EXCELLENT"] = "excellent";
    IMAGE_QUALITY["GOOD"] = "good";
    IMAGE_QUALITY["FAIR"] = "fair";
    IMAGE_QUALITY["POOR"] = "poor";
})(IMAGE_QUALITY || (IMAGE_QUALITY = {}));
// File entity types (polymorphic file storage)
export var FILE_ENTITY_TYPE;
(function (FILE_ENTITY_TYPE) {
    // Tenant-scoped entities
    FILE_ENTITY_TYPE["Wafer"] = "wafer";
    FILE_ENTITY_TYPE["Container"] = "container";
    FILE_ENTITY_TYPE["WaferConflict"] = "wafer_conflict";
    FILE_ENTITY_TYPE["ContainerAudit"] = "container_audit";
    FILE_ENTITY_TYPE["TempFingerprint"] = "temp_fingerprint";
    FILE_ENTITY_TYPE["TempFile"] = "temp_file";
    FILE_ENTITY_TYPE["TenantReport"] = "tenant_report";
    //TenantInvoice = 'tenant_invoice',
    FILE_ENTITY_TYPE["TenantExport"] = "tenant_export";
    FILE_ENTITY_TYPE["AiModel"] = "ai_model";
    FILE_ENTITY_TYPE["FloorPlan"] = "floor_plan";
    FILE_ENTITY_TYPE["EntityNote"] = "entity_note";
    // Provider-scoped entities (no tenant)
    FILE_ENTITY_TYPE["ProviderReport"] = "provider_report";
    FILE_ENTITY_TYPE["ProviderInvoice"] = "provider_invoice";
    FILE_ENTITY_TYPE["SystemTemplate"] = "system_template";
    FILE_ENTITY_TYPE["SystemBackup"] = "system_backup";
    FILE_ENTITY_TYPE["SystemConfig"] = "system_config";
})(FILE_ENTITY_TYPE || (FILE_ENTITY_TYPE = {}));
// File categories for organization and filtering
export var FILE_CATEGORY;
(function (FILE_CATEGORY) {
    FILE_CATEGORY["Image"] = "image";
    FILE_CATEGORY["Document"] = "document";
    FILE_CATEGORY["FingerprintImage"] = "fingerprint_image";
    FILE_CATEGORY["TempFingerprint"] = "temp_fingerprint";
    FILE_CATEGORY["TempFile"] = "temp_file";
    FILE_CATEGORY["ReportPdf"] = "report_pdf";
    FILE_CATEGORY["ReportCsv"] = "report_csv";
    FILE_CATEGORY["ReportXlsx"] = "report_xlsx";
    FILE_CATEGORY["ModelWeights"] = "model_weights";
    FILE_CATEGORY["TrainingData"] = "training_data";
    FILE_CATEGORY["InvoicePdf"] = "invoice_pdf";
    FILE_CATEGORY["ExportArchive"] = "export_archive";
})(FILE_CATEGORY || (FILE_CATEGORY = {}));
// Helper function to map orchestrator 'completed' status to backend 'success'
export function mapSlotStatusForBackend(orchestratorStatus) {
    if (orchestratorStatus === 'completed')
        return EFEM_SLOT_STATUS.Success;
    if (orchestratorStatus === 'failed')
        return EFEM_SLOT_STATUS.Failed;
    if (orchestratorStatus === 'no_wafer')
        return EFEM_SLOT_STATUS.NoWafer;
    if (orchestratorStatus === 'uploading')
        return EFEM_SLOT_STATUS.Uploading;
    return EFEM_SLOT_STATUS.Failed; // Default to failed for unknown statuses
}
// Helper function to check if a status is a final status (not intermediate like 'uploading')
export function isFinalSlotStatus(orchestratorStatus) {
    const mapped = mapSlotStatusForBackend(orchestratorStatus);
    return mapped !== EFEM_SLOT_STATUS.Uploading;
}
// Location device types
export var LOCATION_DEVICE_TYPE;
(function (LOCATION_DEVICE_TYPE) {
    LOCATION_DEVICE_TYPE["Anchor"] = "anchor";
    LOCATION_DEVICE_TYPE["Tag"] = "tag";
})(LOCATION_DEVICE_TYPE || (LOCATION_DEVICE_TYPE = {}));
/** States that are allowed to write into tenant-visible current/history/event stores. */
/*export const LOCATION_DEVICE_ALLOWED_STATES: ReadonlySet<DeviceInventoryStatus> = new Set([
  DeviceInventoryStatusSchema.Enum.claimed,
  DeviceInventoryStatusSchema.Enum.active,
]);*/
export const allUserRoleSchema = z.nativeEnum(ALL_USER_ROLES);
export function getRoleDisplayName(role) {
    if (role === ALL_USER_ROLES.tenant_admin || role === ALL_USER_ROLES.provider_admin)
        return 'Administrator';
    if (role === ALL_USER_ROLES.tenant_engineer || role === ALL_USER_ROLES.provider_engineer)
        return 'Engineer';
    if (role === ALL_USER_ROLES.tenant_lead)
        return 'Lead';
    if (role === ALL_USER_ROLES.provider_support)
        return 'Support';
    if (role === ALL_USER_ROLES.provider_deployment_engineer)
        return 'Deployment Engineer';
    return role.toString();
}
export function isProviderRole(role) {
    if (!role)
        return false;
    return role === ALL_USER_ROLES.provider_admin ||
        role === ALL_USER_ROLES.provider_engineer ||
        role === ALL_USER_ROLES.provider_support ||
        role === ALL_USER_ROLES.provider_deployment_engineer;
}
export function isTenantRole(role) {
    if (!role)
        return false;
    return role === ALL_USER_ROLES.tenant_admin ||
        role === ALL_USER_ROLES.tenant_lead ||
        role === ALL_USER_ROLES.tenant_engineer;
}
export function sizeMatch(waferSize, containerSize) {
    if (waferSize === WAFER_SIZE.Size150mm && containerSize === CONTAINER_SIZE.Size150mm)
        return true;
    if (waferSize === WAFER_SIZE.Size200mm && containerSize === CONTAINER_SIZE.Size200mm)
        return true;
    if (waferSize === WAFER_SIZE.Size300mm && containerSize === CONTAINER_SIZE.Size300mm)
        return true;
    if (waferSize === WAFER_SIZE.Size450mm && containerSize === CONTAINER_SIZE.Size450mm)
        return true;
    return false;
}
/** Map EFEM load port size to inventory container size (same mm label where supported). */
export function loadPortSizeToContainerSize(loadPortSize) {
    switch (loadPortSize) {
        case EFEM_LOAD_PORT_SIZE.Size200mm:
            return CONTAINER_SIZE.Size200mm;
        case EFEM_LOAD_PORT_SIZE.Size450mm:
            return CONTAINER_SIZE.Size450mm;
        case EFEM_LOAD_PORT_SIZE.Size300mm:
        default:
            return CONTAINER_SIZE.Size300mm;
    }
}
//# sourceMappingURL=data.types.js.map